'use strict';


require('../public/css/footer.css');
require('../public/css/bootstrap-social.css');

var React = require('react');
var FormatMessage = require('react-globalize').FormatMessage;
var Link = require('react-router').Link;


var BfgFooter = React.createClass({

  getInitialState: function () {
    return {
      locale: this.props.locale
    }
  },
  render: function () {

    var androidActImage = 'img/android/google-play-badge-es.png';
    var appleActImage = 'img/apple/Download_on_the_App_Store_Badge_ES_RGB_blk_100217.svg';

    if (this.props.locale != 'es') {
      androidActImage = "img/android/google-play-badge.png";
      appleActImage = 'img/apple/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg';
    }
    return (
      <div id="footer-v2" className="footer-v2">
        <div className="footer">
          <div className="container">
            <div className="row">
              <div className="col-md-3 col-sm-4 col-xs-5 md-margin-bottom-40" >
                <ul className="list-unstyled" style={{ "marginBottom": "0px" }}>
                  <li>
                    <a href="/">
                      <img className="img-responsive footerLogos" src="img/bfgLogo.jpg" alt="Logo" />
                    </a>
                  </li>
                  <li style={{ marginTop: "5%" }}>
                    <a href="http://www.msbassociation.org" target="_blank">
                      <img className="img-responsive footerLogos" src="img/bfg_MSBA.jpg" alt="Logo" />
                    </a>
                  </li>
                  <li>
                    <div className="row" style={{display:'flex', justifyContent:'center', marginTop:15}}>
                      <a href="https://play.google.com/store/apps/details?id=com.barrigroup.barrimobile.a01&referrer=utm_source%3Dbfg-it-4%26utm_medium%3Dwpd%26utm_term%3Dsend%252Bmoney%26utm_content%3Dc01%26utm_campaign%3Dmbt"
                        target="_blank"
                        className=""
                      >
                        <img src={androidActImage}
                          width="auto" height="40"
                          className="img-responsive"
                          style={{
                            "height": "40px",
                            "margin" : 5
                          }}
                          alt="Get it on Google Play"
                        />
                      </a>
                    </div>
                    <div className="row" style={{display:'flex', justifyContent:'center'}}>
                      <a href="https://itunes.apple.com/app/apple-store/id1291545810?pt=118817520&ct=bfg-it-4&mt=8"
                        target="_blank"
                        className=""
                      >
                        <img src={appleActImage}
                          width="auto" height="40"
                          className="img-responsive"
                          style={{
                            "height": "45px",
                            "margin" : 5
                          }}
                          alt="Download on the App Store"
                        />
                      </a>
                    </div>
                  </li>
                </ul>

              </div>
              <div className="col-md-3 col-xs-10 md-margin-bottom-40" >
                <div className="headline"><h2 className="heading-sm"><FormatMessage locale={this.props.locale} path="footer/footerLinks" /></h2></div>
                <ul className="list-unstyled link-list">
                  <li><Link to="/aboutBarri" activeClassName="active"><FormatMessage locale={this.props.locale} path="footer/footerBarri" /></Link></li>
                  <li><Link to="/clientService" activeClassName="active"><FormatMessage locale={this.props.locale} path="footer/footerClient" /></Link></li>
                  <li><Link to="/locations" activeClassName="active"><FormatMessage locale={this.props.locale} path="footer/footerLocation" /></Link></li>
                  <li><Link to="/texaslocations" activeClassName="active"><FormatMessage locale={this.props.locale} path="footer/footerLocationsInTexas" /></Link></li>
                  <li><Link to="/employment" activeClassName="active"><FormatMessage locale={this.props.locale} path="footer/footerEmployment" /></Link></li>
                  <li><Link to="/agent" activeClassName="active"><FormatMessage locale={this.props.locale} path="footer/footerAgent" /></Link></li>
                  <li><Link to="/cd" activeClassName="active"><FormatMessage locale={this.props.locale} path="footer/footerAdditional" /></Link></li>
                </ul>
              </div>
              <div className="col-md-3 col-xs-10 md-margin-bottom-40" >
                <div className="latest-tweets">
                  <div className="headline"><h2 className="heading-sm"><FormatMessage locale={this.props.locale} path="footer/footerInformation" /></h2></div>
                  <ul className="list-unstyled link-list">

                    {/* <li><Link to="/bfgTermsCond?text=tc" activeClassName="active"><FormatMessage locale={this.props.locale} path="footer/footerTermsCond" /></Link></li>
       <li><Link to="/bfgTermsCond?text=pp" activeClassName="active"><FormatMessage locale={this.props.locale} path="footer/footerCompliance" /></Link></li>
       <li><Link to="/bfgTermsCond?text=es" activeClassName="active"><FormatMessage locale={this.props.locale} path="footer/footerESign" /></Link></li>
       <li><Link to="/bfgTermsCond?text=fc" activeClassName="active"><FormatMessage locale={this.props.locale} path="footer/footerCompliant" /></Link></li>
       <li><Link to="/bfgTermsCond?text=sl" activeClassName="active"><FormatMessage locale={this.props.locale} path="footer/footerStateLLC" /></Link></li>
       <li><Link to="/bfgResolution" activeClassName="active"><FormatMessage locale={this.props.locale} path="footer/footerResolution" /></Link></li> */}

                    <li><Link to="/bfgPrivacySt" activeClassName="active"><FormatMessage locale={this.props.locale} path="footer/footerCompliance" /></Link></li>
                    <li><Link to="/bfgglbanotice" activeClassName="active"><FormatMessage locale={this.props.locale} path="footer/footerGLBANotice" /></Link></li>
                    <li><Link to="/dataProtection" activeClassName="active"><FormatMessage locale={this.props.locale} path="footer/footerDataProtection" /></Link></li>
                    <li><Link to="/bfgStatePrivacyRights" activeClassName="active"><FormatMessage locale={this.props.locale} path="footer/footerStatePrivacyRight" /></Link></li>
                    <li><Link to="/bfgDoNotSellMyPersonalInformation" activeClassName="active"><FormatMessage locale={this.props.locale} path="footer/footerDoNotSellMyPersonalInformation" /></Link></li>
                    <li><Link to="/bfgTermsCond" activeClassName="active"><FormatMessage locale={this.props.locale} path="footer/footerTermsCond" /></Link></li>
                    {/*<li><Link to="/UserAgreement" activeClassName="active"><FormatMessage locale={this.props.locale} path="footer/UserAgreement" /></Link></li>*/}
                    <li><Link to="/bfgESign" activeClassName="active"><FormatMessage locale={this.props.locale} path="footer/footerESign" /></Link></li>
                    <li><Link to="/BfgFileACompliant" activeClassName="active"><FormatMessage locale={this.props.locale} path="footer/footerCompliant" /></Link></li>
                    <li><Link to="/BfgStatesLLC" activeClassName="active"><FormatMessage locale={this.props.locale} path="footer/footerStateLLC" /></Link></li>

                    <li><Link to="/bfgResolution" activeClassName="active"><FormatMessage locale={this.props.locale} path="footer/footerResolution" /></Link></li>
                    {/* <li><Link to="/bfgNotice" activeClassName="active"><FormatMessage locale={this.props.locale} path="footer/footerNotice" /></Link></li> */}

                    <li><Link to="/bfgtobbacoPurchSalePol" activeClassName="active"><FormatMessage locale={this.props.locale} path="footer/tobbacoPurchSalePol" /></Link></li>
                    {/* <li><a href="http://scamawareness.org" className="active" target="_blank">ScamAwareness.org</a></li> */}
                    <li><Link to="/FraudAware" activeClassName="active"><FormatMessage locale={this.props.locale} path="footer/fraudAware" /></Link></li>
                    <li><Link to="/ElderyFinancialAbuse" activeClassName="active"><FormatMessage locale={this.props.locale} path="footer/footerElderyFinancialAbuse" /></Link></li>
                    <li><Link to="/LawEnforcementRequest" activeClassName="active"><FormatMessage locale={this.props.locale} path="footer/footerLawEnforcementRequest" /></Link></li>
                    <li><Link to="/LegalNotices" activeClassName="active"><FormatMessage locale={this.props.locale} path="footer/footerLegalNotices" /></Link></li>
                    {/*<li><a href="/documents/CaliforniaConsumerRequest.pdf" target="blank" activeClassName="active"><FormatMessage locale={this.props.locale} path="footer/footerCalifornia" /></a></li>*/}
                  </ul>
                </div>
              </div>

              <div className="col-md-3 col-xs-10 md-margin-bottom-40" >
                <div className="headline"><h2 className="heading-sm">​​​​​​​​​<FormatMessage locale={this.props.locale} path="footer/footerContact" /></h2></div>
                <address className="md-margin-bottom-40">
                  <i className="fa fa-home"></i>10777 Westheimer Road, Suite 1040, Houston,TX 77042, USA.<br />
                  <i className="fa fa-phone"></i>1-800-926-2277 <br />
                  <i className="fa fa-globe"></i><a href="http://www.barri.com">http://www.barri.com </a> <br />
                  <i className="fa fa-envelope"></i><a href="mailto:info@barri.com">info@barri.com</a>
                </address>
                <ul className="social-icons">
                  <li><a className="btn btn-social-icon btn-twitter" href="https://twitter.com/BarriGroup" target="_blank"><span className="fa fa-twitter"></span></a></li>
                  <li><a className="btn btn-social-icon btn-facebook" href="https://www.facebook.com/Barrigroup/" target="_blank"><span className="fa fa-facebook"></span> </a></li>
                  <li><a className="btn btn-social-icon btn-linkedin" href="https://www.linkedin.com/company/barri-financial-group" target="_blank"><span className="fa fa-linkedin"></span> </a></li>
                </ul>
                <ul className="social-icons" style={{color: "#555"}}>
                  <li><span className="">BARRI MONEY SERVICES, LLC</span></li>
                  <li><span className="">NMLS ID: 937962</span></li>                  
                </ul>
                <ul className="social-icons" style={{color: "#555"}}>
                  <li><span className=""><FormatMessage locale={this.props.locale} path="footer/footerNYDisclaimer" /></span></li>        
                </ul>
                <ul className="social-icons" style={{color: "#555"}}>
                  <li><span className=""><FormatMessage locale={this.props.locale} path="footer/footerDisclaimerDolex" /></span></li>        
                </ul>
              </div>

              {/* <div className="col-md-2" style={{marginLeft : 25}}>
                <img className="img-responsive footerLogos" src="img/barriQR.png" alt="Qr" />
              </div> */}
            </div>
          </div>
          <div className="copyright">
            <div className="container">
              <p className="text-center">All Rights Reserved ® Barri Money Services 2023</p>
            </div>
          </div>

        </div>
      </div>
    )
  }
})


module.exports = BfgFooter



// WEBPACK FOOTER //
// ./js/footer.js